import * as React from "react";

import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import RadioInput from "@tunnel-components/@sharded/widgets/forms/input/radio/custom/component";
import TextInput from "@tunnel-components/@sharded/widgets/forms/input/text/normal/component";
import * as shortid from "shortid";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    textValue,
    onSubmit,
    onChangeValue,
    disabled,
    checked,
    onChecked,
    displayArray,
  } = props;
  // const homeConfirmation : string[] = ["Afficher tous les incidents non qualifiés (en cours ou terminés)", "Ne pas afficher les incidents non qualifiés s’ils sont terminés"];
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  return (
    <li className="homeDisplay" key={shortid.generate()}>
      <BoxGrid
        title={i18next.t("AFFICHAGE FAUSSE ALARME")}
        classNames="boderShadow"
        error={disabled}
        onSubmit={onSubmit}
        BtnTextSpan={i18next.t("enregistrer")}
      >
        <div className="boxGridContentInsider">
          <div className="boxGridContentText">
            <div className="left boxGridTextText">
              <span>
                {i18next.t("duree d’affichage d’une fausse alarme")} :
              </span>
            </div>
            <div className="left boxGridTextText">
              <TextInput
                maxLength={5}
                name="incidentDuration"
                value={textValue}
                onChangeValue={onChangeValue}
                disabled={disabled}
                autoComplete="off"
                autoFocus={true}
              />
            </div>
            <div className="left boxGridTextText">
              <span>
                {i18next.t("secondes, à compter de sa qualification")}
              </span>
            </div>
          </div>
          <div className="boxGridContentText">
            <div className="left boxGridTextText">
              <span>{i18next.t("incidents non qualifiés")}</span>
            </div>
            <div className="left boxGridTextRadio">
              {displayArray &&
                displayArray.map((Elem: any, index: any) => {
                  return (
                    <RadioInput
                      key={index}
                      name="radio"
                      id={index}
                      checked={checked[index]}
                      disabled={disabled}
                      onChecked={onChecked(index)}
                      label={Elem}
                    />
                  );
                })}
            </div>
          </div>
        </div>
      </BoxGrid>
    </li>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  textValue?: any;
  onSubmit?: any;
  onChangeValue?: any;
  disabled?: any;
  checked?: any;
  onChecked?: any;
  displayArray?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/display/home/component.tsx